import { trackStructEvent } from "@snowplow/browser-tracker";

import { Events,WishlistContext } from "./../types";
import { submitSPEvents } from "./emitSnowplowEvent";

type EmitNotifyProps = WishlistContext["options"] & {
  action: "Add" | "Remove";
};

export function emitNotify({ product_id, page_type, action }: EmitNotifyProps) {
  trackStructEvent({
    category: "Notify me",
    action,
    property: "notify_me",
  });
  submitSPEvents<WishlistContext>([
    {
      context: Events.WISHLIST,
      options: {
        page_type,
        product_id,
      },
    },
  ]);
}
